import { when } from '@execonline-inc/maybe-adapter';
import { Menu } from '@headlessui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Dropdown from './Dropdown';
import FilterButtonText from './FilterButtonText';
import ProductTypeFilterStore from './Store';
import { ProductTypeFilterOptions } from './Types';

interface Props {
  productTypeFilterStore: ProductTypeFilterStore;
  options: ProductTypeFilterOptions[];
}

const ProductTypeFilter: React.FC<Props> = ({ productTypeFilterStore, options }) => (
  <div className="flex md:flex-row">
    <div className="mr-3">
      <Menu as="div">
        {({ open }) => (
          <>
            <Menu.Button
              onClick={() =>
                when(open, {})
                  .do(() => productTypeFilterStore.close())
                  .elseDo(() => productTypeFilterStore.open())
              }
              className={clsx(
                'mt-1 block w-48 rounded-md border-1 border-solid',
                'border-gray-300 bg-white px-3 py-2 text-sm font-medium',
              )}
            >
              <FilterButtonText productTypeFilterStore={productTypeFilterStore} />
            </Menu.Button>
            {when(open, {})
              .map(() => (
                <Dropdown productTypeFilterStore={productTypeFilterStore} options={options} />
              ))
              .getOrElse(() => (
                <></>
              ))}
          </>
        )}
      </Menu>
    </div>
  </div>
);

export default observer(ProductTypeFilter);
